import axios from 'axios'
import qs from 'qs'
import { saveState, getSavedState } from '@state/helpers'
import mapApiUrl from '@/src/utils/api-mapper'

export const state = {
  dailyDrillingCurrentSelected: getSavedState(
    'form.dailyDrillingCurrentSelected'
  ),
  dailyDrillingReport: getSavedState('form.dailyDrillingReport'),
  plannerCostContractBundle: [],
  plannerCostGeneralComponent: [],
  plannerCostItem: [],
  plannerCost: [],
  plannerCostUnit: getSavedState('form.plannerCostUnit'),
  plannerActivity: [],
  plannerActivityCost: [],
  plannerActivityCostAll: [],
  dailyDrillingGeneral: getSavedState('form.dailyDrillingGeneral'),
  comboWellbore: [],
  comboRigOps: [],
  dailyDrillingPersonal: getSavedState('form.dailyDrillingPersonal'),
  dailyDrillingSimplyHoleSection: getSavedState(
    'form.dailyDrillingSimplyHoleSection'
  ),
  masterSurveyList: getSavedState('form.masterSurveyList'),
  generalLotfit: getSavedState('form.generalLotfit'),
  generalLotfitPump: getSavedState('form.generalLotfitPump'),
  diameterOptions: ['4 1/2', '5', '5 1/2', '6 5/8', '7', '7 5/8', '7 3/4', '8 5/8', '9 5/8', '10 3/4', '11 3/4', '11 7/8', '13 3/8', '13 1/2', '13 5/8', '14', '16', '18 5/8', '20', '22', '24', '26', '30', '32', '36', '40', '42'],
}

export const mutations = {
  SET_LIST(state, newValue) {
    state.dailyDrillingReport = newValue
    saveState('form.dailyDrillingReport', newValue)
  },
  SET_PLANNER_COST_CONTRACT_BUNDLE(state, newValue) {
    state.plannerCostContractBundle = newValue
  },
  SET_PLANNER_COST_GENERAL_COMPONENT(state, newValue) {
    state.plannerCostGeneralComponent = newValue
  },
  SET_PLANNER_COST_ITEM(state, newValue) {
    state.plannerCostItem = newValue
  },
  SET_PLANNER_COST(state, newValue) {
    state.plannerCost = newValue
  },
  SET_PLANNER_COST_UNIT(state, newValue) {
    state.plannerCostUnit = newValue
    saveState('form.plannerCostUnit', newValue)
  },
  SET_PLANNER_ACTIVITY(state, newValue) {
    state.plannerActivity = newValue
  },
  SET_PLANNER_ACTIVITY_COST(state, newValue) {
    state.plannerActivityCost = newValue
  },
  SET_PLANNER_ACTIVITY_COST_ALL(state, newValue) {
    state.plannerActivityCostAll = newValue
  },
  SET_DAILY_DRILLING_GENERAL(state, newValue) {
    state.dailyDrillingGeneral = newValue
    saveState('form.dailyDrillingGeneral', newValue)
  },
  SET_DAILY_DRILLING_CURRENT_SELECTED(state, newValue) {
    state.dailyDrillingCurrentSelected = newValue
    saveState('form.dailyDrillingCurrentSelected', newValue)
  },
  SET_COMBO_WELLBORE(state, newValue) {
    state.comboWellbore = newValue
  },
  SET_COMBO_RIGOPS(state, newValue) {
    state.comboRigOps = newValue
  },
  SET_DAILY_DRILLING_PERSONAL(state, newValue) {
    state.dailyDrillingPersonal = newValue
    saveState('form.dailyDrillingPersonal', newValue)
  },
  SET_DAILY_DRILLING_SIMPLY_HOLE_SECTION(state, newValue) {
    state.dailyDrillingSimplyHoleSection = newValue
    saveState('form.dailyDrillingSimplyHoleSection', newValue)
  },
  SET_MASTER_SURVEY_LIST(state, newValue) {
    state.masterSurveyList = newValue
    saveState('form.masterSurveyList', newValue)
  },
  SET_GENERAL_LOTFIT(state, newValue) {
    state.generalLotfit = newValue
    saveState('form.generalLotfit', newValue)
  },
  SET_GENERAL_LOTFIT_PUMP(state, newValue) {
    state.generalLotfitPump = newValue
    saveState('form.generalLotfitPump', newValue)
  },
}

export const getters = {
  dailyDrillingReport(state) {
    return state.dailyDrillingReport || []
  },
  plannerCCB(state) {
    return state.plannerCostContractBundle || []
  },
  plannerCGC(state) {
    return state.plannerCostGeneralComponent || []
  },
  plannerCI(state) {
    return state.plannerCostItem || []
  },
  plannerCost(state) {
    return state.plannerCost || []
  },
  plannerCostUnit(state) {
    return state.plannerCostUnit || []
  },
  plannerActivity(state) {
    return state.plannerActivity || []
  },
  plannerActivityCost(state) {
    return state.plannerActivityCost || []
  },
  plannerActivityCostAll(state) {
    return state.plannerActivityCostAll || []
  },
  dailyDrillingGeneral(state) {
    return state.dailyDrillingGeneral || []
  },
  dailyDrillingCurrentSelected(state) {
    return state.dailyDrillingCurrentSelected || {}
  },
  comboWellbore(state) {
    return state.comboWellbore || []
  },
  comboRigOps(state) {
    return state.comboRigOps || []
  },
  dailyDrillingPersonal(state) {
    return state.dailyDrillingPersonal || []
  },
  dailyDrillingSimplyHoleSection(state) {
    return state.dailyDrillingSimplyHoleSection || []
  },
  generalLotfit(state) {
    return state.generalLotfit || []
  },
  generalLotfitPump(state) {
    return state.generalLotfitPump || []
  },
  diameterOptions(state) {
    return state.diameterOptions || []
  }
}

export const actions = {
  setDailyDrillingReport({ commit }, list) {
    commit('SET_LIST', list)
  },
  setPlannerCostContractBundle({ commit }, list) {
    commit('SET_PLANNER_COST_CONTRACT_BUNDLE', list)
  },
  setPlannerCostGeneralComponent({ commit }, list) {
    commit('SET_PLANNER_COST_GENERAL_COMPONENT', list)
  },
  setPlannerCostItem({ commit }, list) {
    commit('SET_PLANNER_COST_ITEM', list)
  },
  setPlannerCost({ commit }, list) {
    commit('SET_PLANNER_COST', list)
  },
  setPlannerCostUnit({ commit }, list) {
    commit('SET_PLANNER_COST_UNIT', list)
  },
  setPlannerActivity({ commit }, list) {
    commit('SET_PLANNER_ACTIVITY', list)
  },
  setPlannerActivityCost({ commit }, list) {
    commit('SET_PLANNER_ACTIVITY_COST', list)
  },
  setPlannerActivityCostAll({ commit }, list) {
    commit('SET_PLANNER_ACTIVITY_COST_ALL', list)
  },
  setDailyDrillingGeneral({ commit }, list) {
    commit('SET_DAILY_DRILLING_GENERAL', list)
  },
  setDailyDrillingCurrentSelected({ commit }, obj) {
    commit('SET_DAILY_DRILLING_CURRENT_SELECTED', obj)
  },
  setComboWellbore({ commit }, list) {
    commit('SET_COMBO_WELLBORE', list)
  },
  setComboRigOps({ commit }, list) {
    commit('SET_COMBO_RIGOPS', list)
  },
  setDailyDrillingPersonal({ commit }, list) {
    commit('SET_DAILY_DRILLING_PERSONAL', list)
  },
  setDailyDrillingSimplyHoleSection({ commit }, list) {
    commit('SET_DAILY_DRILLING_SIMPLY_HOLE_SECTION', list)
  },
  setMasterSurveyList({ commit }, list) {
    commit('SET_MASTER_SURVEY_LIST', list)
  },
  setGeneralLotfit({ commit }, list) {
    commit('SET_GENERAL_LOTFIT', list)
  },
  setGeneralLotfitPump({ commit }, list) {
    commit('SET_GENERAL_LOTFIT_PUMP', list)
  },

  getDailyDrillingReport({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/list/pageable')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data.content : null
        dispatch('setDailyDrillingReport', list)
        return response
      })
  },

  // SHS = Simply Hole Section
  // getMasterSHSList({ commit, dispatch, getters }, { params } = {}) {
  //   const url = '/api/form/master/simply_hole_section/review/submit';
  //   return axios
  //     .get(url, { params: params })
  //     .then((response) => {
  //       return response
  //     })
  // },

  getPlannerCostContractBundle({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerCostContractBundle', [])
    const url = mapApiUrl('/api/form/planner/cost/contract-bundle/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setPlannerCostContractBundle', list)
        return response
      })
  },

  getPlannerCostGeneralComponent(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    dispatch('setPlannerCostGeneralComponent', [])
    const url = mapApiUrl('/api/form/planner/cost/general-component/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : []
        dispatch('setPlannerCostGeneralComponent', list)
        return response
      })
  },

  getPlannerCostItem({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerCostItem', [])
    const url = mapApiUrl('/api/form/planner/cost/cost-item/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : []
        dispatch('setPlannerCostItem', list)
        return response
      })
  },

  getPlannerCostItemAll({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerCostItem', [])
    const url = mapApiUrl('/api/form/planner/cost/cost-item/list/all')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : []
        dispatch('setPlannerCostItem', list)
        return response
      })
  },

  getPlannerCost({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerCost', [])
    const url = mapApiUrl('/api/form/planner/cost/data/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data.content : []
        dispatch('setPlannerCost', list)
        return response
      })
  },

  getPlannerCostUnit({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerCostUnit', [])
    const url = mapApiUrl('/api/form/planner/cost-unit/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : []
        dispatch('setPlannerCostUnit', list)
        return response
      })
  },

  getPlannerActivity({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerActivity', [])
    const url = mapApiUrl('/api/form/planner/activity/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : []
        dispatch('setPlannerActivity', list)
        return response
      })
  },

  getPlannerActivityCost({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerActivityCost', [])
    const url = mapApiUrl('/api/form/planner/activity-cost/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : []
        dispatch('setPlannerActivityCost', list)
        return response
      })
  },

  getPlannerActivityCostAll({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setPlannerActivityCostAll', [])
    const url = mapApiUrl('/api/form/planner/activity-cost/list_all')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : []
        dispatch('setPlannerActivityCostAll', list)
        return response
      })
  },

  addPlannerCostContractBundle({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost/contract-bundle/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updatePlannerCostContractBundle(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/planner/cost/contract-bundle/rename')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  deletePlannerCostContractBundle(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/planner/cost/contract-bundle/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  addPlannerCostGeneralComponent(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/planner/cost/general-component/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updatePlannerCostGeneralComponent(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/planner/cost/general-component/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  deletePlannerCostGeneralComponent(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/planner/cost/general-component/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeReportActivity({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeReportDailyDrilling({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dailydrilling/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeReportSubsurface({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  addPlannerCostItem({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost/cost-item/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      console.log('response', response)
      return response
    })
  },

  updatePlannerCostItem({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost/cost-item/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      console.log('response', response)
      return response
    })
  },

  deletePlannerCostItem({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost/cost-item/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  addPlannerActivity({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/activity/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },
  updatePlannerActivity({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/activity/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  deletePlannerActivity({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/activity/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  addPlannerActivityCost({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/activity-cost/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updatePlannerActivityCost({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/activity-cost/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  deletePlannerActivityCost({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/activity-cost/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  addPlannerCostUnit({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost-unit/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addDailyDrillingReport({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addDailyDrillingGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  uploadDailyDrillingGeneral(formData) {
    const url = mapApiUrl('/api/form/master/general/upload')
    return axios
      .post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response
      })
  },

  // downloadTemplate(formData) {
  //   const url = '/api/form/report/templates/download/ddr'
  //   return axios.get(url, formData).then((response) => {
  //     return response
  //   })
  // },

  downloadTemplate({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/report/templates/download/ddr')
    return axios
      .get(
        url,
        { params: params },
        {
          headers: {
            'Content-Disposition': 'attachment; filename=template.xlsx',
            'Content-Type': 'application/octet-stream',
          },
          responseType: 'blob',
        }
      )
      .then((response) => {
        return response
        // const url = window.URL.createObjectURL(new Blob([response.data]))
        // const link = document.createElement('a')
        // link.href = url
        // link.setAttribute('download', 'template.xlsx')
        // document.body.appendChild(link)
        // link.click()
      })
  },

  // downloadTemplate(_url, title) {
  //   axios({
  //     method: 'get',
  //     _url,
  //     responseType: 'arraybuffer',
  //   })
  //     .then((response) => {
  //       // const url = window.URL.createObjectURL(new Blob([response.data]))
  //       // const link = document.createElement('a')
  //       // link.href = url
  //       // link.setAttribute('download', title)
  //       // document.body.appendChild(link)
  //       // link.click()
  //     })
  //     .catch((e) => console.log(e,'error occured'))
  // },

  addMasterLotfit({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterLotfitPump({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/add/pump')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListSurveyStationType(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=surveys&combo_name=station_type&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListBulkUnitSize({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/combo/list?form_id=bulk&combo_name=unit_size&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboCementStageType({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=cement&combo_name=stage_type&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListCompany({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/company/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getComboOptionPhasecode({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=ops_summary&combo_name=phase_code&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboOptionActivitycode({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=ops_summary&combo_name=activity_code&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboOptionSubactivitycode(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=ops_summary&combo_name=subactivity_code&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboOptionActivitycategory(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=ops_summary&combo_name=activity_category&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboOptionNptcode({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=ops_summary&combo_name=npt_code&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListActivityCategory({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=ops_summary&combo_name=activity_category&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListContractBundle({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost/contract-bundle/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getComboListGeneralComponent({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost/general-component/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getComboListCostItem({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/planner/cost/cost-item/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getComboListBitNo({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/workstring/bitdata/get/bitno')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getComboListWorkstringSectionType(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=section_type&ref_id=')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getComboListWorkstringComponentType(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=working_string&combo_name=component_type')
    // {{ API_URL_FORM  }}/combo/list?form_id=working_string&combo_name=component_type&ref_id=CAS
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  // start workstring bitdata
  getComboListWorkstringDrillMode(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=drill_mode&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringSize({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=general&combo_name=hole_size&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListJobType({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=cement&combo_name=job_type&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListKickOccur({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=general&combo_name=kick_occur&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListKickProc({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=general&combo_name=kick_proc&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboOptionList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/combo/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityGeneralWorkJobType(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/generalwork/fix/jobtype/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getSubsurfaceAlterationTypeList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/subsurface/report/alterationtype/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getComboListKickClass({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=general&combo_name=kick_class&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListCasingSize({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=casing&combo_name=casing_size&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListGrade({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=casing&combo_name=casing_grade&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListAssemblyType({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=casing&combo_name=assembly_type&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListTabularType({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=casing&combo_name=tabular_type&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringInnerRow(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=inner_row&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringOuterRow(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=outer_row&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringDullChar(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=dull_char&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringLocation(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=location&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringBearingSeals(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=bearing_seals&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringGauge({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=gauge&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringOtherDullChar(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=other_dull_char&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getComboListWorkstringReasonPulled(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl(
      '/api/form/combo/list?form_id=workstring&combo_name=reason_pulled&ref_id=')
    return axios.get(url, qs.stringify(params)).then((response) => {
      return response
    })
  },
  // end workstring bitdata

  removeMasterSHS({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/simply_hole_section/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterSurvey({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/survey/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterMud({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/mud/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterBulk({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/bulk/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCasing({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeSubsurfaceFormReport({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/report/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityLoggingInterval(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/logging/interval/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityFishingGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/general/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityFishingFreePoint(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/freepoint/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityFishingResult({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/result/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityFishingResponsibleParties(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/responsibleparties/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityFishingStringShot(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/stringshot/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityFishingWellboreObstruction(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCoringSidewallDesc(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/coring/sidewall/desc/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCoringDesc({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/desc/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityGeneralWorkOps({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/ops/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCementFluid({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCementStage({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/stage/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCementIsoInt({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/isointerval/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCementPumpSch({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/pumpsch/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCementIntCirculation(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/cement/intcirculation/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeActivityCasingTally({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/tally/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterPersonal({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterPersonalBySubmitId(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/personal/remove/submitid')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterOpsum({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/ops_sum/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterCost({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/cost/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterEnvActivityDischarge(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/discharge/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterEnvActivityRecovery(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/recovery/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterEnvActivityDisposal(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/disposal/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterEnvActivitySpill({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/env_activity/spill/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterWorkstringBitData(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bitdata/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterWorkstringBha({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/workstring/bha/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterWorkstringBhaContent(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bha_content/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterEnvActivityCutting(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/cutting/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterSafetyIncident({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/incident/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterDrillingParameters({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/drilling-parameters/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  updateMasterSHS({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/simply_hole_section/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateApprovalStatus({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/submitted/approved')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterSurvey({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/survey/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterBulk({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/bulk/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterPersonal({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterOpsum({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/ops_sum/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterCost({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/cost/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterEnvActivityDischarge(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/discharge/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterEnvActivityRecovery(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/recovery/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterEnvActivityDisposal(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/disposal/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterEnvActivitySpill({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/env_activity/spill/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterWorkstringBitData(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bitdata/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterWorkstringBha({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/workstring/bha/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterWorkstringBhaContent(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bha_content/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterEnvActivityCutting(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/cutting/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  // SHS = Simply Hole Section
  addMasterSHS({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/simply_hole_section/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterMud({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/mud/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityKick({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/kick/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityWellTest({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/welltest/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityFishingGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/general/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityFishingFreePoint({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/freepoint/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityFishingResult({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/result/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityFishingResponsibleParties(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/responsibleparties/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityFishingStringShot({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/stringshot/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityFishingWellboreObstruction(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityLoggingInterval({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/logging/interval/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityLogging({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/logging/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCoring({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityGeneralWorkFix({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/fix/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityGeneralWorkOps({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/ops/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCoringDesc({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/desc/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCoringSidewallDesc(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/coring/sidewall/desc/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCementFix({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fix/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterDDRGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterMud({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/mud/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityKick({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/kick/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityWellTest({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/welltest/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityLoggingInterval(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/logging/interval/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityFishingGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/general/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityFishingFreePoint(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/freepoint/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityFishingResult({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/result/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityFishingResponsibleParties(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/responsibleparties/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityFishingStringShot(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/stringshot/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityFishingWellboreObstruction(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityLogging({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/logging/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCoring({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityDatabaseCoring({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/database/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityGeneralWorkFix({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/fix/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityGeneralWorkOps({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/ops/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCoringDesc({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/desc/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },
  updateActivityDatabaseCoringDesc(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/coring/desc/database/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCoringSidewallDesc(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/coring/sidewall/desc/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityDatabaseCoringSidewallDesc(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/coring/sidewall/desc/database/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCementFix({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fix/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterDDRGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterSafetyIncident({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/incident/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterSafetyIncident({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/incident/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterSafety({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterSafety({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterSurvey({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/survey/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterBulk({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/bulk/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCasing({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/update')
    return axios.patch(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityDatabaseCasing({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/database/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateSubsurfaceFormReport({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/report/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCasingTally({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/tally/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityDatabaseCasingTally(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/casing/tally/database/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCasing({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addSubsurfaceFormReport({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/report/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCementFluid({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCementStage({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/stage/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCementIsoInt({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl( '/api/form/activity/cement/isointerval/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCementPumpSch({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/pumpsch/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCementIntCirculation(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/cement/intcirculation/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCementFluid({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCementStage({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/stage/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCementIsoInt({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/isointerval/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCementPumpSch({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/pumpsch/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateActivityCementIntCirculation(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/cement/intcirculation/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addActivityCasingTally({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/tally/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterPersonal({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterOpsum({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/ops_sum/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterCost({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/cost/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterEnvActivityDischarge(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/discharge/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterEnvActivityRecovery({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/env_activity/recovery/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterEnvActivityDisposal({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/env_activity/disposal/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterEnvActivitySpill({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/env_activity/spill/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterWorkstringBitData({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/workstring/bitdata/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterWorkstringBha({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/workstring/bha/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterWorkstringBhaContent(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bha_content/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterWorkstringBitdata({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/workstring/bitdata/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addMasterEnvActivityCutting({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/env_activity/cutting/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  removeMasterLotfit({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/remove')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  removeMasterLotfitPump({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/remove/pump')
    return axios
      .delete(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  updateMasterLotfit({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateMasterLotfitPump({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/update/pump')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getDashboardWellPlaneView({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/well/planeview')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getLogs({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/identity/logs/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardWellGraph({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/well/graph')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardBitPerformance({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/bitperformance')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardDvd({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/dvd')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardDvc({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/dvc')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardNptBreakdown({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/nptbreakdown')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardDrillingParameters({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/drilling-parameters/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDrillingParametersFormList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/drilling-parameters/get/forms')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardCostActualVsPlan({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/costactualvsplan')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterCostCarryOver({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/cost/get/carryover')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardCostPerContract({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/costpercontract')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardTimelineProgress({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/timelineprogress')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardPtNpt({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/ptnpt')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardNptHoleSection({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/nptholesection')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardActivityBreakdown(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/dashboard/activitybreakdown')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardAfevsActual({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/costafevsactual')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardDays10k({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/days10k')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDashboardDvdvcPlan({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dashboard/dvdvc/plan')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterMud({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/mud/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityKick({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/kick/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityWellTest({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/welltest/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityLoggingInterval({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/logging/interval/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityLogging({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/logging/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/general/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingFreePoint({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/freepoint/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingResult({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/result/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingResponsibleParties(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/responsibleparties/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingStringShot({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/fishing/stringshot/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getOpsSumMaxDate({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/ops_sum/get/maxdate')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingWellboreObstruction(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCoring({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityGeneralWorkFix({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/fix/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityGeneralWorkOps({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/ops/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCoringDesc({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/desc/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCoringSidewallDesc(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/coring/sidewall/desc/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementFix({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fix/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterDDRGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterDDRGetPrevMD({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/get_last_md')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterSafetyIncident({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/incident/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterSafety({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  updateDailyDrillingGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getDailyDrillingGeneral({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setDailyDrillingGeneral', list)
        return response
      })
  },

  getComboWellbore({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setComboWellbore', [])
    const url = mapApiUrl('/api/form/master/wellbore/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setComboWellbore', list)
        return response
      })
  },

  getComboRigOps({ commit, dispatch, getters }, { params } = {}) {
    dispatch('setComboRigOps', [])
    const url = mapApiUrl('/api/form/master/rigops/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setComboRigOps', list)
        return response
      })
  },

  getDailyDrillingPersonal({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setDailyDrillingPersonal', list)
        return response
      })
  },

  getDailyDrillingSimplyHoleSection(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/simply_hole_section/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setDailyDrillingSimplyHoleSection', list)
        return response
      })
  },

  getMasterSurveyList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/survey/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setMasterSurveyList', list)
        return response
      })
  },

  getMasterBulkList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/bulk/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCasingList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getSubsurfaceReportResultList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/subsurface/report/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCasingTallyList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/tally/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityReportList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityReportListWithStatus(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/list/status')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDailyDrillingReportList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dailydrilling/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getSubmittedReportListMap({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/submitted/list/map')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getSubmittedReportContext({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/submitted/report-context')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getSubmittedCostReport({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/submitted/report-cost')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getSubsurfaceReportList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementFluid({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementStage({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/stage/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementIsoInt({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/isointerval/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementPumpSch({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/pumpsch/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementIntCirculation(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/cement/intcirculation/review')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFluidNameList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/fluidname/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityStageNoList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/stage/stageno/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityClassList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/class/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityDescriptionList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/description/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityPurposeList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/purpose/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityTypeList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/type/list')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterGeneralByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterDfsByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/get/dfs')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterDolByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/general/get/dol')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterPersonalByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterLotfitByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterLotfitPumpByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/pump/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterShsByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/simply_hole_section/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterSurveyByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/survey/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterMudByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/mud/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterBulkByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/bulk/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementIntCirculationByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/cement/intcirculation/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCasingByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/casing/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementStageByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/stage/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCoringByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/coring/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingGeneralByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/general/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingFreePointByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/freepoint/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingRespPartByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/responsibleparties/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingResultByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/result/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingStringShotByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/stringshot/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityFishingWellboreObsByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityGeneralWorkByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/generalwork/fix/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityGeneralWorkOpsByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/generalwork/ops/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getSubsurfaceByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityWellTestByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/welltest/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityLoggingByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/logging/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityLoggingIntervalByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/logging/interval/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCoringSidewallByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/coring/sidewall/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementIsolatedIntervalByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/activity/cement/isointerval/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementFluidByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fluid/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityCementFixByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/cement/fix/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getActivityKickByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/kick/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityDisposalByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/disposal/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityRecoveryByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/recovery/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityDischargeByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/discharge/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivitySpillByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/spill/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityCuttingByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/cutting/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterSafetyByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/safety/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterSafetyIncidentByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/safety/incident/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterWorkstringBitDataByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bitdata/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterWorkstringBHAByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/workstring/bha/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterWorkstringBHAContentByWell(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bha_content/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterCostByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/cost/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterOpsumByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/ops_sum/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getDailyDrillingWitingForApproval(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/submitted/waiting/approved')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterPersonalList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterLastPersonalList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/get/last_personal')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterOpsum({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/ops_sum/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterCostList({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/cost/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityDischargeList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/discharge/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityRecoveryList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/recovery/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityDisposalList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/disposal/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivitySpillList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/spill/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterWorkstringBitDataList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bitdata/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterWorkstringBhaList({ commit, dispatch, getters }, { params } = {}) {
    // const url = mapApiUrl('/api/form/master/workstring/bha/review/submit')
    const url = mapApiUrl('/api/form/master/workstring/bha/get/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterWorkstringBhaContentList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/workstring/bha_content/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getMasterEnvActivityCuttingList(
    { commit, dispatch, getters },
    { params } = {}
  ) {
    const url = mapApiUrl('/api/form/master/env_activity/cutting/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },

  getGeneralLotfit({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/shs/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setGeneralLotfit', list)
        return response
      })
  },

  getGeneralLotfitBySubmitId({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/review/submit')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setGeneralLotfit', list)
        return response
      })
  },

  getGeneralLotfitPump({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/lotfit/review/submit/pump')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        const list = response ? response.data.data : null
        dispatch('setGeneralLotfitPump', list)
        return response
      })
  },

  addDailyDrillingPersonal({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/personal/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addReportActivity({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addReportDailyDrilling({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dailydrilling/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  addReportSubsurface({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/add')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  submitReportActivity({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/submit')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  submitReportDailyDrilling({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dailydrilling/submit')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  submitReportSubsurface({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/submit')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateReportActivity({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/activity/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateReportDailyDrilling({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/dailydrilling/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateReportSubsurface({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/subsurface/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  updateStatus({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/master/status/update')
    return axios.post(url, qs.stringify(params)).then((response) => {
      return response
    })
  },

  getOpsumByWell({ commit, dispatch, getters }, { params } = {}) {
    const url = mapApiUrl('/api/form/daily-operation-summary/list/well')
    return axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        return response
      })
  },
}
